import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormArray, FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { ServiceordreDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/serviceordre-dto';
import { ServiceordreStatusEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/serviceordre-status-enum';

@Component({
    selector: 'app-open-orders-cancel',
    templateUrl: './open-orders-cancel.component.html',
    styleUrls: ['./open-orders-cancel.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OpenOrdersCancelComponent implements OnInit {
  @Output() cancelOrderChanged: EventEmitter<number[]> = new EventEmitter();

  private _allOrders: ServiceordreDto[] = [];
  @Input() set allOrders(value: ServiceordreDto[]) {
    this._allOrders = value;
    this.updateOpenOrders();
  }
  private _endDate: Date;
  @Input() set endDate(value: Date) {
    this._endDate = value;
    this.updateOpenOrders();
  }

  get terminationCauseForServiceordre() {
    return this.form.get('terminationCauseForServiceordre');
  }

  @Input() form: UntypedFormGroup;
  openOrders: ServiceordreDto[] = [];
  dataSource = new BehaviorSubject<ServiceordreDto[]>([]);
  ordersToBeCanceled: Map<number, ServiceordreDto> = new Map<number, ServiceordreDto>();

  activeColumns: string[] = ['markAction', 'ordrenr', 'opgave', 'deadline', 'status', 'beskrivelse'];

  openOrderStates: ServiceordreStatusEnum[] = [
    ServiceordreStatusEnum.Broadcasted,
    ServiceordreStatusEnum.Created,
    ServiceordreStatusEnum.ReadyForBroadcast,
    ServiceordreStatusEnum.ValidationFailed,
  ];

  constructor() {}

  ngOnInit(): void {
    this.updateOpenOrders();
  }

  isOrderAfterDeadline(serviceorder: ServiceordreDto): boolean {
    return new Date(serviceorder.deadline) >= this._endDate;
  }

  onServicOrderCheckChange(checked: boolean, serviceordre: ServiceordreDto) {
    if (checked) {
      this.ordersToBeCanceled.set(serviceordre.serviceordreNo, serviceordre);
    } else {
      this.ordersToBeCanceled.delete(serviceordre.serviceordreNo);
    }
    this.cancelOrderChanged.emit(Array.from(this.ordersToBeCanceled.keys()));
  }

  updateOpenOrders() {
    this.ordersToBeCanceled = new Map<number, ServiceordreDto>();
    this.openOrders = this._allOrders.filter((x) => Object.values(this.openOrderStates).includes(x.serviceordreStateEnum));
    let ordersAfterDeadline = this.openOrders.filter((x) => new Date(x.deadline) >= this._endDate);
    ordersAfterDeadline.forEach((order) => {
      this.ordersToBeCanceled.set(order.serviceordreNo, order);
    });
    this.cancelOrderChanged.emit(Array.from(this.ordersToBeCanceled.keys()));
    this.dataSource.next(this.openOrders);
  }
}
